import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './home.component';
import {NewdelegationComponent} from './newdelegation/newdelegation.component';
import {CommonNewDelegationComponent} from 'common-domain';
import {PATH_CONSTANTS} from '../app-routing.module';
import {HomeComponentAuthGuard} from './HomeComponentAuthGuard';
import {RecoverUserNameInitComponent} from "./recover-user-name-init/recover-user-name-init.component";
import {AcTcConfirmationComponent} from "./ac-tc-confirmation/ac-tc-confirmation.component";
import {ResetPasswordInitComponent} from "./reset-password-flow/reset-password-init/reset-password-init.component";
import {ResetPasswordCompleteComponent} from "./reset-password-flow/reset-password-complete/reset-password-complete.component";
import {ChangeExpiredPasswordComponent} from './change-expired-password/change-expired-password.component';
import {MfaLoginVerificationCodeComponent} from "./mfa-login-verification-code/mfa-login-verification-code.component";
import {ResetPasswordMfaComponent} from "./reset-password-flow/reset-password-mfa/reset-password-mfa.component";

export const HOME_PATH_CONSTATNTS = {
  HOME: PATH_CONSTANTS.HOME,
  NEW_DELEGATION: PATH_CONSTANTS.HOME + PATH_CONSTANTS.SLASH + 'newdelegation',
  START_NEW_DELEGATION: PATH_CONSTANTS.HOME + PATH_CONSTANTS.SLASH + 'startdelegation' + PATH_CONSTANTS.SLASH,
  RESET_PASSWORD_INIT: PATH_CONSTANTS.HOME + PATH_CONSTANTS.SLASH + 'resetPassword',
  RECOVER_USERNAME_INIT: PATH_CONSTANTS.HOME + PATH_CONSTANTS.SLASH + 'recoverUserName',
  RESET_PASSWORD_COMPLETE: PATH_CONSTANTS.HOME + PATH_CONSTANTS.SLASH + 'resetPasswordComplete' + PATH_CONSTANTS.SLASH,
  AC_TC_CONFIRMATION: PATH_CONSTANTS.HOME + PATH_CONSTANTS.SLASH + 'contact-confirmation' + PATH_CONSTANTS.SLASH,
  CHANGE_PASSWORD: 'changePassword'

};
const homeRoutes: Routes = [
  {
    path: HOME_PATH_CONSTATNTS.HOME,
    canActivate: [HomeComponentAuthGuard],
    component: HomeComponent
  }, {
    path: HOME_PATH_CONSTATNTS.NEW_DELEGATION,
    component: NewdelegationComponent
  }, {
    path: HOME_PATH_CONSTATNTS.START_NEW_DELEGATION + ':name',
    component: CommonNewDelegationComponent
  }, {
    path: HOME_PATH_CONSTATNTS.RESET_PASSWORD_INIT,
    component: ResetPasswordInitComponent
  }, {
    path: HOME_PATH_CONSTATNTS.RESET_PASSWORD_COMPLETE + ':token'+"/:correlationId" + "/:mfaCode",
    component: ResetPasswordCompleteComponent
  }, {
    path: HOME_PATH_CONSTATNTS.RESET_PASSWORD_COMPLETE + ':token'+"/:correlationId",
    component: ResetPasswordCompleteComponent
  }, {
    path: HOME_PATH_CONSTATNTS.RECOVER_USERNAME_INIT,
    component: RecoverUserNameInitComponent
  }, {
    path: HOME_PATH_CONSTATNTS.AC_TC_CONFIRMATION + ':token' + "/:data",
    component: AcTcConfirmationComponent
  },{
    path: HOME_PATH_CONSTATNTS.CHANGE_PASSWORD,
    component: ChangeExpiredPasswordComponent
  },
  {
    path: 'mfa-login-verification-code/:token',
    component: MfaLoginVerificationCodeComponent
  },
  {
    path: 'home/reset-password-mfa/:token/:correlationId',
    component: ResetPasswordMfaComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(homeRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class HomeRoutingModule {
}
